/* eslint-disable no-undef */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
// @ts-nocheck
import PopupInputCode from "components/popup-input-code";
import PopupMessage from "components/popup-message";
import PopupOtp from "components/popup-otp";
import {
  BUSINESS_ACCOUNT_ID,
  CAMPAIGNID,
  END_DATE,
  END_DATE_TIME,
  SAAS_CAMPAIGNID,
  START_DATE,
  START_DATE_TIME,
  TENANTID,
} from "constants/common";
import moment from "moment";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";
import actions from "redux/home/actions";
import actionsPrize from "redux/prize/actions";
import { signInWithCustomToken, getAuth } from "firebase/auth";
import LoadingSpinner from "components/LoadingSpinner";
import PopupGiftTopup from "components/popup-gift-topup";
import PopupNoGift from "components/popup-no-gift";
import { checkPhoneNetwork } from "utils";
import Cookies from "universal-cookie";
import $ from "jquery";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CardPageView from "./view";
import LoadingUpload from "components/LoadingUpload";
const CardPage = () => {
  const navigate = useNavigate();
  const myRef = useRef(null);
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
    getValues,
    reset,
  } = useForm();
  const cookies = new Cookies();
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [modalOtp, setModalOtp] = useState(false);
  const [modalInput, setModalInput] = useState(false);
  const [content, setContent] = useState("");
  const [otp, setOtp] = useState("");
  const [isErrorOTP, setIsErrorOTP] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingUpload, setIsLoadingUpload] = useState(false);
  const [isShowModalTopup, setIsShowModalTopup] = useState(false);
  const [isShowModalNoGift, setIsShowModalNoGift] = useState(false);
  const [code, setCode] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [OtpRequestTime, setOtpRequestTime] = useState("");
  const [OtpResponseTime, setOtpResponseTime] = useState("");
  const [dataSubmit, setDataSubmit] = useState({});
  const [nameBtn, setNameBtn] = useState("");
  const [nameBtn1, setNameBtn1] = useState("");
  const [nameBtn2, setNameBtn2] = useState("");
  const [timerId, setTimerId] = useState(null);
  const [dataModalTopup, setDataModalTopup] = useState({});
  const [provinces, setProvinces] = useState([]);
  const [isErrorPhoneNumber, setIsErrorPhoneNumber] = useState(false);
  const [networkPhone, setNetworkPhone] = useState("");
  const [isCommingSoon, setCommingSoon] = useState(true);
  const isEnableButton = useRef(false);
  const [provinceSelected, setProvinceSelected] = useState("");
  const HOTLINE = "Hotline <strong>1900......</strong>";
  const [listSpecial, setListSpecial] = useState([]);
  const [listPicture, setListPicture] = useState([]);
  const [searchParams] = useSearchParams();
  const { state } = useLocation();

  localStorage.removeItem("rule");
  const [textAreaCount, ChangeTextAreaCount] = React.useState(0);
  const isUserUsingMobile = () => {
    // Screen resolution method
    let screenWidth = window.screen.width;
    return screenWidth < 992;
  };

  const addDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.add("disabled");
    isEnableButton.current = false;
  };

  const removeDisableBtn = (id) => {
    const el = document.querySelector(id);
    el.classList.remove("disabled");
    isEnableButton.current = true;
  };
  const showModal = () => {
    setModal(true);
    document.body.classList.add("modal-open");
  };
  const hideModal = () => {
    setModal(false);
    document.body.classList.remove("modal-open");
  };
  const onSubmit = () => {};

  const clearFieldFormData = () => {};

  const recalculate = (e) => {
    ChangeTextAreaCount(e.target.value.length);
  };
  const checkError = (errCode) => {
    let content = "";

    switch (errCode) {
      case "MaxFailPerDay":
        content = `Quý khách đã gửi sai mã dự thưởng 5 lần liên <br/>tiếp và sẽ không được tiếp tục tham gia<br/> chương trình trong ngày hôm nay.<br/> Hãy trở lại sau nhé. ${HOTLINE}`;
        setNameBtn(`ĐÓNG`);
        break;

      case "MaxJoin":
        content = `Thuê bao đã đạt giới hạn số lần tham gia dự thưởng. Vui lòng quay trở lại sau.<br/>${HOTLINE}`;
        setNameBtn(`ĐÓNG`);
        break;

      case "CAMPAIGN_NOT_START_YET":
        content = `Chương trình chưa bắt đầu, vui lòng quay trở lại vào ngày <span>${START_DATE}</span>.`;
        setNameBtn(`ĐÓNG`);

        break;

      case "CAMPAIGN_ENDED":
        content = `Chương trình đã kết thúc, hẹn gặp lại bạn ở các chương trình sau!`;
        setNameBtn(`ĐÓNG`);

        break;
      case "INVALID_PHONE_NUMBER":
        content = `Chương trình đã kết thúc, hẹn gặp lại bạn ở các chương trình sau!`;
        setNameBtn(`ĐÓNG`);
        break;
      case "InvalidResendTime":
        content = `<p>Yêu cầu gửi mã OTP của bạn đang được chúng tôi xử lý, bạn hãy thử lại sau 1 phút nhé.<p/>`;
        setNameBtn(`ĐÓNG`);
        break;
      case "RECEIVER_NAME_LIMIT":
        content = `<p>
Tên người nhận đã vượt quá ký tự cho phép,
Vui lòng kiểm tra lại.<p/>`;
        setNameBtn(`ĐÓNG`);
        break;
      case "CONTENT_LIMIT":
        content = `<p>
Nội dung lời chúc đã vượt quá ký tự cho phép,
Vui lòng kiểm tra lại<p/>`;
        setNameBtn(`ĐÓNG`);
        break;
      case "CARD_LIMIT":
        content = `Bạn đã tạo quá số lượng thiệp cho phép của chương trình. Hẹn gặp lại bạn ở chương trình khác`;
        setNameBtn(`ĐÓNG`);
        break;
      case 502:
        content = `Chúng tôi không thể nhận diện được người trong ảnh của bạn. Vui lòng chọn một bức ảnh khác rõ ràng hơn và gửi lại nhé!`;
        setNameBtn(`ĐÓNG`);
        break;
      default:
        content = `Đã có lỗi xảy ra!<br/>
        Vui lòng kiểm tra lại`;
        setNameBtn(`ĐÓNG`);
        break;
    }
    showModal();
    setContent(`${content}`);
  };
  return (
    <div>
      <LoadingSpinner isLoading={isLoading} />
      <LoadingUpload isLoadingUpload={isLoadingUpload} />

      <CardPageView
        recalculate={recalculate}
        textAreaCount={textAreaCount}
        register={register}
        setValue={setValue}
        getValues={getValues}
        handleSubmit={handleSubmit(onSubmit)}
        listSpecial={listSpecial}
        listPicture={listPicture}
        clearFieldFormData={clearFieldFormData}
        removeDisableBtn={removeDisableBtn}
        addDisableBtn={addDisableBtn}
        setIsLoading={setIsLoading}
        setIsLoadingUpload={setIsLoadingUpload}
        checkError={checkError}
      />

      {isShowModalTopup && (
        <PopupGiftTopup
          dataModalTopup={dataModalTopup}
          phoneNumber={phoneNumber}
          onTopupMobile={onTopupMobile}
          networkPhone={networkPhone}
        />
      )}
      {isShowModalNoGift && (
        <PopupNoGift
          dataModalTopup={dataModalTopup}
          closeModal={setIsShowModalNoGift}
        />
      )}

      {modal && (
        <PopupMessage
          nameBtn={nameBtn}
          nameBtn1={nameBtn1}
          nameBtn2={nameBtn2}
          setModal={setModal}
          content={content}
          clickAction={hideModal}
          clickAction1={hideModal}
          clickAction2={hideModal}
        />
      )}
      {/* {modalInput && <PopupInputCode setModalInput={setModalInput} content={content} />} */}
    </div>
  );
};

export default CardPage;
